import React, { useEffect, useLayoutEffect, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default function ClusteredAmChart(props) {
  const { targetData, isMyPerformance } = props;
  const [viewData, setViewData] = useState([]);

  useEffect(() => {
    if (targetData) {
      const order = ["Hayyak", "Baqati", "HBB", "Upgrade"];

      const data = order.map((key) => ({
        category: key,
        sales: parseInt(targetData?.[key]?.sales_count) || 0,
        target: parseInt(targetData?.[key]?.target) || 0,
        achievement: parseInt(targetData?.[key]?.achieved_percentage) || 0,
      }));

      setViewData(data);
    }
  }, [targetData]);

  useLayoutEffect(() => {
    const chart = am4core.create("chartdiv5", am4charts.XYChart);
    chart.scrollbarX = new am4core.Scrollbar();

    chart.data = viewData;

    // Create axes
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "category";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 60;
    categoryAxis.tooltip.disabled = true;

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.minWidth = 50;
    valueAxis.min = 0;
    valueAxis.cursorTooltipEnabled = false;

    let paretoValueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    paretoValueAxis.renderer.opposite = true;
    paretoValueAxis.min = 0;
    paretoValueAxis.strictMinMax = true;
    paretoValueAxis.renderer.grid.template.disabled = true;
    paretoValueAxis.numberFormatter = new am4core.NumberFormatter();
    paretoValueAxis.numberFormatter.numberFormat = "#'%'";
    paretoValueAxis.cursorTooltipEnabled = false;

    let paretoSeries = chart.series.push(new am4charts.LineSeries());
    paretoSeries.dataFields.valueY = "achievement";
    paretoSeries.dataFields.categoryX = "category";
    paretoSeries.yAxis = paretoValueAxis;
    paretoSeries.tooltipText = "Achievement: {valueY.formatNumber('#.0')}%[/]";
    paretoSeries.bullets.push(new am4charts.CircleBullet());
    paretoSeries.strokeWidth = 2;
    paretoSeries.stroke = new am4core.InterfaceColorSet().getFor(
      "alternativeBackground",
    );
    paretoSeries.strokeOpacity = 0.5;

    // Cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.behavior = "panX";

    chart.colors.step = 2;

    chart.legend = new am4charts.Legend();
    chart.legend.position = "top";
    chart.legend.paddingBottom = 20;
    chart.legend.labels.template.maxWidth = 95;

    function createSeries(value, name) {
      const series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = value;
      series.dataFields.categoryX = "category";
      series.name = name;

      const bullet = series.bullets.push(new am4charts.LabelBullet());
      bullet.interactionsEnabled = false;
      bullet.dy = 30;
      bullet.label.text = "{valueY}";
      bullet.label.fill = am4core.color("#ffffff");

      series.columns.template.column.cornerRadiusTopLeft = 10;
      series.columns.template.column.cornerRadiusTopRight = 10;
      series.columns.template.column.fillOpacity = 0.8;
      series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
      series.columns.template.strokeWidth = 0;

      let hoverState = series.columns.template.column.states.create("hover");
      hoverState.properties.cornerRadiusTopLeft = 0;
      hoverState.properties.cornerRadiusTopRight = 0;
      hoverState.properties.fillOpacity = 1;

      return series;
    }

    // Modify chart's colors
    chart.colors.list = [
      am4core.color("#0063a4"),
      am4core.color("#f89d21"),
      am4core.color("#f89d21").lighten(0.3),
      am4core.color("#0063a4").lighten(0.1),
      am4core.color("gray"),
      am4core.color("#f89d21").lighten(0.2),
    ];

    createSeries("sales", "Sales");
    createSeries("target", "Target");

    return () => {
      chart.dispose();
    };
  }, [viewData]);

  return (
    <div
      style={{
        width: "100%",
        fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
        background: "#f7f8fc",
        borderRadius: 16,
        padding: "28px 24px",
      }}
    >
      {/* Card Header */}
      <div style={{ marginBottom: 20 }}>
        <div
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: "#aaa",
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            marginBottom: 4,
          }}
        >
          {isMyPerformance ? "My Performance" : "Staff Performance"}
        </div>
        <div style={{ fontSize: 24, fontWeight: 700, color: "#1a1a2e" }}>
          Target vs Achievement
        </div>
      </div>

      {/* White card wrapping the chart */}
      <div
        style={{
          background: "#fff",
          borderRadius: 14,
          overflow: "hidden",
          boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
          padding: "24px 16px",
        }}
      >
        <div id="chartdiv5" style={{ width: "100%", height: "500px" }} />
      </div>
    </div>
  );
}
